import React, { useContext, useState, useEffect } from 'react';
import './generalServices.css';
import { LanguageContext } from '../../../context/LanguageContext/LanguageContext';
import { generalServices, generalServicesEn } from '../../../json/generalServices';
import { Link } from 'react-router-dom';

// Hook para detectar si es móvil
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const GeneralServices = () => {
  const { language } = useContext(LanguageContext);
  const data = language === 'ES' ? generalServices : generalServicesEn;

  const isMobile = useIsMobile();

  return (
    <div
      className="container services-container"
      style={isMobile ? { overflow: "hidden" } : {}}
    >
      <div className="row g-0"> {/* Bootstrap row sin espacios entre columnas */}
        {data.map((service, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-4">
            <div
              className={`service-card ${index % 2 === 0 ? 'black-bg' : 'yellow-bg'}`}
            >
              <h3 dangerouslySetInnerHTML={{ __html: service.title }}></h3>
              <p>{service.description}</p>
              <div className='content-arrow-link'>
                <Link to={service.link} className="arrow-link">
                  <span>➔</span>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneralServices;
